module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#play",
      toString: function () {
        return this.url;
      }
    }